/**
 * StatusChip — pill consistente de estado para las cabeceras de los
 * bloques del Informe (y de cualquier otra sección que distinga relleno
 * vs vacío). Mantiene el mismo lenguaje visual en los 6 apartados.
 */
import { CheckCircle, Clock } from "@phosphor-icons/react";

export default function StatusChip({ filled, testid }) {
  if (filled) {
    return (
      <span
        data-testid={testid}
        data-state="completed"
        className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-status-success-bg text-status-success-fg"
      >
        <CheckCircle className="w-3 h-3" weight="fill" />
        Completado
      </span>
    );
  }
  return (
    <span
      data-testid={testid}
      data-state="pending"
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide bg-background text-muted border border-border"
    >
      <Clock className="w-3 h-3" weight="regular" />
      Pendiente
    </span>
  );
}
